import BlFieldMv from './BlFieldMv.vue'

BlFieldMv.install = function(Vue) {
  Vue.component(BlFieldMv.name, BlFieldMv)
}

export default BlFieldMv
